
/**
 * Date formats
 */
export const dateFormatStandard = 'DD-MM-YYYY';
export const dateFormatWithTime = 'DD-MM-YYYY HH:mm';
